<template>
  <div class="acctContract">
    <div class="topArea">
      <div class="banner">
        <div class="mname">{{customer.customerName}}</div>
        <div class="contract"><span>合同编号：</span><span>{{contract.contractNo}}</span></div>
      </div>
    </div>
    <van-row class="cell type">
      <van-row class="border cell-body">
        <van-col span="6" class="title">服务项目</van-col>
        <van-col span="18" class="rightText">代理记账：{{customer.acctType == 3 ? '记账+报税' : (customer.acctType == 1 ? '记账' : '报税')}}</van-col>
      </van-row>
    </van-row>
    <van-row class="cell">
      <van-row class="border cell-body">
        <van-col span="8" class="title">合同起止月份</van-col>
        <van-col v-if="contract.startYear!=0" span="16" class="rightText">{{contract.startYear + "年" + contract.startMonth + "月" + '~' + contract.endYear + "年" + contract.endMonth + "月"}}</van-col>
      </van-row>
    </van-row>
    <van-row class="cell">
      <van-row class="border cell-body">
        <van-col span="6" class="title">收款方式</van-col>
        <van-col span="18" class="rightText">{{contract.collectionWay == 1 ? '先收款后服务' : '先服务后收款'}}</van-col>
      </van-row>
    </van-row>
    <van-row class="cell">
      <van-row class="cell-body">
        <van-col span="6" class="title">收款周期</van-col>
        <van-col span="18" class="rightText">{{customer.collectionPeriod}}</van-col>
      </van-row>
    </van-row>
    
    <van-row class="cell type">
      <van-row class="border cell-body">
        <van-col span="6" class="title">合同金额</van-col>
        <van-col span="18" class="rightText">{{contract.contractFee}}</van-col>
      </van-row>
    </van-row>
    <van-row class="cell">
      <van-row class="border cell-body">
        <van-col span="6" class="title">月服务费</van-col>
        <van-col span="18" class="rightText">{{formatMonthFee(contract.monthFee)}}</van-col>
      </van-row>
    </van-row>
    <van-row class="cell">
      <van-row class="cell-body">
        <van-col span="6" class="title">账本费</van-col>
        <van-col span="18" class="rightText">{{contract.yearFee}}</van-col>
      </van-row>
    </van-row>

    <van-row class="cell type">
      <van-row class="border cell-body">
        <van-col span="6" class="title">服务成本</van-col>
        <van-col span="18" class="rightText">{{contract.serviceCost}}</van-col>
      </van-row>
    </van-row>
    <van-row class="cell">
      <van-row class="border cell-body">
        <van-col span="6" class="title">其他成本</van-col>
        <van-col span="18" class="rightText">{{contract.otherCost}}</van-col>
      </van-row>
    </van-row>
    <van-row class="cell">
      <van-row class="border cell-body">
        <van-col span="6" class="title">签约日期</van-col>
        <van-col span="18" class="rightText">{{contract.contractDate && contract.contractDate.split(" ")[0] || ''}}</van-col>
      </van-row>
    </van-row>
    <van-row class="cell">
      <van-row class="border cell-body">
        <van-col span="6" class="title">业务员</van-col>
        <van-col span="18" class="rightText">{{contract.staff}}</van-col>
      </van-row>
    </van-row>
    <van-row class="cell">
      <van-row class="cell-body">
        <van-col span="6" class="title">备注</van-col>
        <van-col span="18" class="rightText">{{contract.conRemark}}</van-col>
      </van-row>
    </van-row>
  </div>
</template>

<script>
import Vue from "vue";
import { Row, Col, Icon, Toast } from "vant";
Vue.use(Row)
  .use(Col)
  .use(Icon);

export default {
  name: "acctContract",
  components: {
  },
  data() {
    return {
      customer: this.$store.state.wechatCollectionInfo,
      contract:{}
    };
  },

  methods: {
    init() {
      this.getContractDetail();
    },
    formatMonthFee(monthFee){
      monthFee = Number(monthFee).toFixed(9)
      let index = monthFee.indexOf('.')
      return monthFee.substr(0, index+3)
    },
   
    linkSkip(name, params, redType, rid) {
      if (rid) {
        this.$root.$emit("log-record", rid);
      }
      this.$router.push({
        name: name,
        query: params
      });
    },
    getContractDetail() {
      let url = "/fc/small/program/contract?companyId=" + this.customer.companyId;
      this.$http
        .get(url)
        .then(res => {
          if (res.data.code == 200) {
            console.log(res, "/fc/small/program/contract");
            this.contract = res.data.data;
          } else {
            Toast(res.data.msg);
          }
        })
        .catch(error => {
          Toast(error);
        });
    }
  },
  mounted: function() {
    this.$root.$emit('log-record',"70000006");
    //滚动条置顶
    document.documentElement.scrollTop = document.body.scrollTop = 0;
    this.init();
  }
};
</script>

<style type="text/css" lang="stylus" scoped>
.acctContract {
  height: 100%;
  position: relative;

  .topArea {
    background-color: #ffffff;
  }

  .banner {
    width: 3.65rem;
    height: 1.38rem;
    margin: 0 auto;
    background: url('../../../assets/wxRenew/banner-bg.png') no-repeat center;
    background-size: cover;
    text-align center
    color #ffffff
    overflow hidden
  }

  .cell {
    background-color: #ffffff;
    font-size: 0.16rem;
    padding-left: 0.16rem;
  }

  .cell-body {
    padding: 0.16rem 0.12rem;
    padding-left: 0;
  }

  .title {
    color: #1A2633;
    font-size: 0.17rem;
  }

  .rightText {
    text-align: right;
    color: #516374;
    font-size: 0.14rem;
    line-height: 0.23rem;
  }

  .leftText {
    color: #516374;
    font-size: 0.14rem;
  }

  .type {
    margin-top: 0.08rem;
  }

  .margnTop {
    margin-top: 0.1rem;
  }

  .task {
    color: #516374;
  }

  .pcolor {
    color: #1fadf6;
  }

  .border {
    border-bottom: 1px solid #f0f2f2;
  }
  .mname{
    margin-top 0.4rem
    font-size 0.2rem
    font-weight bold
  }
  .contract{
    margin-top 0.04rem
  }
}
</style>
